const { v4: uuidv4 } = require('uuid');
const moment = require('moment');
require('moment-timezone');

//==================================================================================
// Strings
//==================================================================================

exports.spinalToCamel = s => s.replace(/-./g, x=>x.toUpperCase()[1])

exports.spinalToSnake = s => s.split('-').join('_')

exports.snakeToSpinal = s => s.split('_').join('-')

exports.camelToSpinal = s =>  {
    var noCamel = s.replace(/([A-Z])/g, ' $1');
    var newStr = noCamel.replace(/\s|_/g, "-");
    return newStr.toLowerCase();
}

exports.splitLines = body => body.split('\r\n').join('\n').split('\r').join('\n').split('\n').filter(el=>el!='')

exports.removeLineBreaks = body => body.split('\r\n').join('\n').split('\r').join('\n').split('\n').join('')

/**
 * value: UTCISOString YYYY-MM-DDTHH:mm:ss.SSSZ (2021-03-19T10:49:43.007Z)
 * outputTimezone: (Europe/Rome)
 * locale: used to format the output date string (it-it)
 * separator: output date separator
 */
exports.formatDate = (value, outputTimezone, locale, separator) => {
    let localizedDate = utcToWorkingTimeZone(value, outputTimezone)
    return _formatDate(localizedDate.slice(0,10), locale, separator)
}

/**
 * value: UTCISOString YYYY-MM-DDTHH:mm:ss.SSSZ (2021-03-19T10:49:43.007Z)
 * outputTimezone: (Europe/Rome)
 * locale: used to format the output date string (it-it)
 * dateSeparator: output date fragment separator
 * dateTimeSeparator: output dateTime fragment separator
 * timeSeparator: output time fragment separator
 */
exports.formatDateTime = (value, outputTimezone, locale, dateSeparator, dateTimeSeparator, timeSeparator) => {
    console.log('formatDateTime - outputTimezone:>> ', outputTimezone);
    let localizedDate = utcToWorkingTimeZone(value, outputTimezone)
    return _formatDate(localizedDate.slice(0,10), locale, dateSeparator) + dateTimeSeparator + _formatTime(localizedDate.slice(11,16), timeSeparator)
}

/**
 * value: UTCISOString YYYY-MM-DDTHH:mm:ss.SSSZ (2021-03-19T10:49:43.007Z)
 * outputTimezone: (Europe/Rome)
 * locale: used to format the output date string (it-it)
 * dateSeparator: output date fragment separator
 * dateTimeSeparator: output dateTime fragment separator
 * timeSeparator: output time fragment separator
 */
exports.formatDateTimeDownToSeconds = (value, outputTimezone, locale, dateSeparator, dateTimeSeparator, timeSeparator) => {
    const _formatTimeDownToSeconds = (value, separator) => {
        const fragments = (value).split(":");
        return fragments[0] + separator + fragments[1] + separator + fragments[2];
    }
    let localizedDate = utcToWorkingTimeZone(value, outputTimezone)
    return _formatDate(localizedDate.slice(0,10), locale, dateSeparator) + dateTimeSeparator + _formatTimeDownToSeconds(localizedDate.slice(11,19), timeSeparator)
}

/**
 * value: UTCISOString YYYY-MM-DDTHH:mm:ss.SSSZ (2021-03-19T10:49:43.007Z)
 * outputTimezone: (Europe/Rome)
 * locale: used to format the output date string (it-it)
 * dateSeparator: output date fragment separator
 * dateTimeSeparator: output dateTime fragment separator
 * timeSeparator: output time fragment separator
 * millisSeparator: output millis fragment separator
 */
exports.formatDateTimeDownToMillis = (value, outputTimezone, locale, dateSeparator, dateTimeSeparator, timeSeparator, millisSeparator) => {
    const _formatTimeDownToMillis = (value, timeSeparator, millisSeparator) => {
        let fragments = (value).split(".");
        const timeDownToSeconds = fragments[0];
        const millis = fragments[1]
        fragments = timeDownToSeconds.split(":");
        return fragments[0] + timeSeparator + fragments[1] + timeSeparator + fragments[2] + millisSeparator + millis;
    }
    let localizedDate = utcToWorkingTimeZone(value, outputTimezone)
    return _formatDate(localizedDate.slice(0,10), locale, dateSeparator) + dateTimeSeparator + _formatTimeDownToMillis(localizedDate.slice(11,23), timeSeparator, millisSeparator)
}

exports.formatTime = (value, locale, separator) => {
    return _formatTime(value, separator);
}

const _formatDate = (value, locale, separator) => {
    let result;
    const fragments = (value).split("-");
    if (locale == "en-us")
        result = fragments[1] + separator + fragments[2] + separator + fragments[0];
    else if (["it-it", "en-gb", "ar-sa"].includes(locale))
        result = fragments[2] + separator + fragments[1] + separator + fragments[0];
    return result;
}

const _formatTime = (value, separator) => {
    const fragments = (value).split(":");
    return fragments[0] + separator + fragments[1];
}

//==================================================================================
// Numbers
//==================================================================================

exports.round = (value, decimalPlaces) => Number((Math.round(value + "e" + decimalPlaces)  + "e-" + decimalPlaces));

exports.floor = (value, decimalPlaces) => Number((Math.floor(value + "e" + decimalPlaces)  + "e-" + decimalPlaces));

exports.ceil = (value, decimalPlaces) => Number((Math.ceil(value + "e" + decimalPlaces)  + "e-" + decimalPlaces));

exports.percentage = (percent, total) => ((percent * 100) / total).toFixed(2)

//==================================================================================
// Time
//==================================================================================

/**
 * Ritorna l'offset in  minuti rispetto all'UTC per il timeZone specificato.
 * Se timeZone vale null la time zone è dedotta dall'ambiente di esecuzione.
 */
const getUtcTimeOffset = (isoStringDate, timeZone=null) => {
    const workingValue = timeZone ? moment().tz(timeZone).format()
                                  : moment.utc(isoStringDate).local().format()
    const fragments = workingValue.slice(19).split(':')
    return Number(fragments[0]*60)+Number(fragments[1])
}
exports.getUtcTimeOffset = getUtcTimeOffset

/**
 * Ritorna il corrispettivo UTC (come ISO string: es. 2021-03-15T18:56:10.670Z) della sysdate per il timeZone specificato.
 * Se timeZone vale null la time zone è dedotta dall'ambiente di esecuzione.
 */
exports.getSysdate = (timeZone=null) => {
    return timeZone ? moment().tz(timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                    : moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
}

exports.getSystemTimeZone = () => moment.tz.guess(true)

/**
 * Ritorna una string ISO
 */
const utcToWorkingTimeZone = (dateAsIsoString, workingTimeZone) => {

    console.log('utcToWorkingTimeZone  workingTimeZone:>> ', workingTimeZone);
    dateAsIsoString =
       dateAsIsoString.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/) ? new Date('1900-01-01T' + dateAsIsoString + ':00.000Z')
          : new Date(dateAsIsoString);
 
    let result;
    if (workingTimeZone == 'UTC')
       result = dateAsIsoString.toISOString();
    else if (workingTimeZone == null) {
       const offset = getUtcTimeOffset(dateAsIsoString);
       result = new Date(dateAsIsoString.setMinutes(dateAsIsoString.getMinutes() + offset)).toISOString()
    } else {
       const offset = getUtcTimeOffset(dateAsIsoString, workingTimeZone);
       result = new Date(dateAsIsoString.setMinutes(dateAsIsoString.getMinutes() + offset)).toISOString()
    }
    return result;
}
exports.utcToWorkingTimeZone = utcToWorkingTimeZone
 
 /**
  * Ritorna una string ISO
  */
exports.workingTimeZoneToUtc = (dateAsIsoString, workingTimeZone) => {
    dateAsIsoString =
       dateAsIsoString.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/) ? new Date('1900-01-01T' + dateAsIsoString + ':00.000Z')
          : new Date(dateAsIsoString);
 
    let result;
    if (workingTimeZone == 'UTC')
       result = dateAsIsoString.toISOString();
    else if (workingTimeZone == null) {
       const offset = getUtcTimeOffset(dateAsIsoString);
       result = new Date(dateAsIsoString.setMinutes(dateAsIsoString.getMinutes() - offset)).toISOString()
    } else {
       const offset = getUtcTimeOffset(dateAsIsoString, workingTimeZone);
       result = new Date(dateAsIsoString.setMinutes(dateAsIsoString.getMinutes() - offset)).toISOString()
    }
    return result;
}

/**
 * Formatta un time in millis in maniera human readable
 */
exports.millisToHuman = (timeMS) => {
    const [MS_IN_SEC, SEC_IN_DAY, SEC_IN_HOUR, SEC_IN_MIN] = [1000, 86400, 3600, 60];
    let seconds = Math.round(Math.abs(timeMS) / MS_IN_SEC);
    const days = Math.floor(seconds / SEC_IN_DAY);
    seconds = Math.floor(seconds % SEC_IN_DAY);
    const hours = Math.floor(seconds / SEC_IN_HOUR);
    seconds = Math.floor(seconds % SEC_IN_HOUR);
    const minutes = Math.floor(seconds / SEC_IN_MIN);
    seconds = Math.floor(seconds % SEC_IN_MIN);
    const [dd, hh, mm, ss] = [days, hours, minutes, seconds]
        .map(item => item < 10 ? '0' + item : item.toString());
    return dd + ':' + hh + ':' + mm + ':' + ss;
}

//==================================================================================
// Json
//==================================================================================

exports.hasAnyProperties = (object) => {
    for (var prop in object) {
        if (object.hasOwnProperty(prop)) 
            return true;
    }
    return false;
}

//==================================================================================
// Arrays
//==================================================================================

/**
 * Restituisce l'intersezione tra arr1 e arr2
 */
exports.intersect = (arr1, arr2) => {
    if(!arr1)
        arr1 = [];
    if(!arr2)
        arr2 = [];
    let result = []
    for (var i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) !== -1) {
            result.push(arr1[i]);
        }
    }
    return result;
}

/**
 * Restituisce la differenza tra arr1 e arr2
 */
exports.subtract = (arr1, arr2) => {
    if(!arr1)
        arr1 = [];
    if(!arr2)
        arr2 = [];
    let result = []
    for (var i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) == -1) {
            result.push(arr1[i]);
        }
    }
    return result;
}

/**
 * Da richiamare in "await" per attendere l'esecuzione di tutte le iterazioni.
 * Cicla sugli elementi di "array" e ad ogni iterazione esegue la funzione "callback" attendendo la conclusione dell'iterazione
 * precedente.
 */
exports.asyncForEach = async (array, callback) => {
    for (let i = 0; i < array.length; i++) {
      await callback(array[i], i, array)
    }
}

/**
 * Restituisce un array di oggetti senza duplicati per un determinato campo dell'oggetto
 * Es. inputArray = [{"essid":"cort1975","quality":"3/5"},
 *                   {"essid":"cort1975","quality":"2/5"},
 *                   {"essid":"allan1972","quality":"3/5"}]
 * outputArray = uniqify(inputArray,'essid');
 * Produce come outputArray [{"essid":"cort1975","quality":"3/5"},
 *                           {"essid":"allan1972","quality":"3/5"}]
 */
exports.uniqify = (array, key) => array.reduce((prev, curr) => prev.find(a => a[key] === curr[key]) ? prev : prev.push(curr) && prev, []);

//==================================================================================
// Random
//==================================================================================

exports.getRandomIntegerFromInterval = (min, max) => Math.floor(Math.random() * ((max+1) - min) + min)

exports.getRandomItemFromArray = domain => {
    const getRandomIntegerFromInterval = (min, max) => Math.floor(Math.random() * ((max+1) - min) + min)
    return domain[getRandomIntegerFromInterval(0, domain.length-1)]
}

exports.getRandomDateFromInterval = (start, end) => {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toISOString()
}

exports.getRandomTime = () => {
    const getRandomIntegerFromInterval = (min, max) => Math.floor(Math.random() * ((max+1) - min) + min)
    return String(getRandomIntegerFromInterval(0,23)).padStart(2, '0')+':'+String(getRandomIntegerFromInterval(0,59)).padStart(2, '0')
}

exports.shuffleArray = input => JSON.parse(JSON.stringify(input)).sort(() => Math.random() - 0.5)

//==================================================================================
// Miscellaneous
//==================================================================================

exports.wait = async (ms) => new Promise(resolve => setTimeout(resolve, ms));

exports.generateUuid = () => uuidv4();

/**
 * returns the remaining time in seconds
 * @param {*} timeout the javascript timeout object
 */
exports.getTimeLeftInSec = (timeout) => (Math.ceil((timeout._idleStart + timeout._idleTimeout)/1000 - process.uptime()))

/**
 * true if value is a correct ip
 * @param value 
 */
exports.validateIpv4Address = (value) => (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value));